const getters = {
  defaultImg: state => state.user.defaultImg,
  defaultHeadImg: state => state.user.defaultHeadImg
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js